import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import ScrollIntoView from "../../../shared/scroll-into-view/scroll-into-view";
import { fetchMakeups } from "./../../accessories/makeup/ducks/actions";
import {
  addMakeupToScene,
  clearRedirect
} from "./ducks/actions";
import Form from "./form";
import Loader from "../../../shared/loader";

function AddVisualEffectToScene(props) {
  const { filmId, sceneId } = props.match.params;
  const {
    fetchMakeups,
    addMakeupToScene,
    clearRedirect,
    errors,
    makeups,
    sceneMakeups,
    saving,
    makeup
  } = props;

  const [fromBreakdown, setFromBreakdown] = useState<boolean>(false);
  useEffect(() => {
    setFromBreakdown(props.location?.state?.fromBreakdown);
  }, [props.location?.state?.fromBreakdown]);

  useEffect(() => {
    fetchMakeups(filmId);
  }, []);

  if (props.redirect) {
    clearRedirect();
    if (props.redirect.to == "list") {
      const url = `/films/${filmId}/scenes/${sceneId}/makeup`;
      return <Redirect to={url} />;
    } else if (props.redirect.to == "breakdown") {
      const url = `/films/${filmId}/breakdown/scenes/${sceneId}`;
      return <Redirect to={url} />;
    }
  }

  function onAddMakeup(makeup) {
    sanitiseDataTypes(makeup);
    addMakeupToScene(filmId, sceneId, makeup, fromBreakdown);
  }

  function sanitiseDataTypes(setDressing) {
  }

  const sceneMakeupIds = sceneMakeups.map(p => p.id);
  const nonSceneMakeups = makeups.filter((makeup: any) => !sceneMakeupIds.includes(makeup.id));

  return (
    <ScrollIntoView
      className="blade-content"
      path="/films/:filmId/scenes/:sceneId/makeup/add"
      loading={false}>
      <Form
        mode="add"
        errors={errors}
        initialValues={makeup}
        makeups={nonSceneMakeups}
        onSubmit={onAddMakeup}
      />
      {saving && <Loader />}
    </ScrollIntoView>
  );
}

function mapStateToProps(state) {
  const { makeupState } = state.scenesState;
  return {
    sceneMakeups: makeupState.makeups,
    makeups: state.makeupState.makeups,
    makeup: makeupState.makeup,
    errors: makeupState.errors,
    redirect: makeupState.redirect,
    saving: makeupState.saving
  };
}

export default connect(mapStateToProps, {
  addMakeupToScene,
  fetchMakeups,
  clearRedirect
})(AddVisualEffectToScene);
